import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../store";

export const isAuthenticatingState = createSlice({
  name: "isAuthenticating",
  initialState: false,
  reducers: {
    set: (state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

const selector = (state: GlobalState) => state.isAuthenticating;
export const selectIsAuthenticating = createSelector(selector, (s) => s);
